import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import info from '../../images/newDesign/infoFilled.svg';
import Input from '../../common/simple/input';
import InputGroup from '../../common/InputGroup';
import Button from '../../common/Button';
import DateMonthPicker from '../../common/DatepickerPortal';
import { SquareCheckbox } from '../../ui/SquareCheckbox';
import {useFormik} from "formik";
import * as yup from "yup";

function UpdateFixedRates({ onSubmit }) {
    const { t, i18n } = useTranslation();
    const ltr = useSelector(state => state.common.ltrEnabled);
    const currencyFromServer = useSelector(state => state.buildings.currentBuildingData?.currency ?? state.buildings.managerData?.currency);
    const currency = currencyFromServer ? t(`currency.${currencyFromServer}`) : t('currency.ils');

    const form = useFormik({
        initialValues: {
            // startDate: new Date(),
            // endDate: new Date(),
            addToExistingRate: false,
            amount: '',
        },
        validationSchema: yup.object().shape({
            amount: yup.number().required(t('titles.forms.mandatory_field')),
        }),
        onSubmit: handleFormSubmit,
    });

    function handleFormSubmit(values, helpers) {
        onSubmit(values);
    }
    return (
        <div className='rates'>
            <form onSubmit={form.handleSubmit}>

            <div className='update-info'>
                <img src={info} />
                <div>{t('payment_settings.updateFixedAmount')}</div>
            </div>

            <div className='input-and-checkbox-wrapper'>
                <div className='input-wrapper'>
                    <div className='input-label'>{t('payment_settings.amountUpdate')}</div>
                    <Input
                        placeholder={`- ${currency}`}
                        type="number"
                        value={form.values.amount}
                        name="amount"
                        onChange={form.handleChange}
                        onBlur={form.handleBlur}
                    />
                    { form.errors.amount && form.touched.amount && (
                        <label className="error">{form.errors.amount}</label>
                    )}
                </div>

                <SquareCheckbox
                    checked={form.values.addToExistingRate}
                    onChange={checked => form.setFieldValue('addToExistingRate', checked)}
                    label={t('payment_settings.addToExistingRate')}
                    containerClassName='checkbox'
                    className='checkbox-input'
                    labelFontWeight='400'
                />
            </div>

            <div className='datepickers-container'>
                <InputGroup
                    labelText={`${t('payment_settings.startingFrom')}`}
                    labelFor='from'
                    labelClassName='datepicker-label'
                >
                    <DateMonthPicker
                        date={form.values.startDate}
                        onChange={date => form.setFieldValue('startDate', date)}
                        id='from'
                        maxDate={form.values.endDate}
                        language={i18n.language}
                        className='one-line-design classic-bllink'
                        withPortal={false}
                        ltr={ltr}
                        showMonthYear
                    />
                </InputGroup>

                <InputGroup
                    labelText={`${t('payment_settings.upTo')}`}
                    labelFor='to'
                    labelClassName='datepicker-label'
                >
                    <DateMonthPicker
                        date={form.values.endDate}
                        onChange={date => form.setFieldValue('endDate', date)}
                        id='to'
                        minDate={form.values.startDate}
                        language={i18n.language}
                        className='one-line-design classic-bllink'
                        withPortal={false}
                        ltr={ltr}
                        showMonthYear
                    />
                </InputGroup>
            </div>

            <div className="btn-wrapper">
                <Button type="submit">{t('payment_settings.update')}</Button>
            </div>

            </form>
        </div>
    )
}

export default UpdateFixedRates;
